import { useMutation } from "@apollo/client/react";
import { CloseOutlined, UndoOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useTranslation } from "react-i18next";
import { DiscardIngredientDraftDocument } from "../../../gql/generated/graphqlSchema.tsx";
import { LoadingBlocker } from "../../../components/LoadingBlocker.tsx";
import { useIngredient } from "../IngredientContext.tsx";

type DiscardIngredientDraftButtonProps = {
  readonly onCompleted: () => void;
};

export const DiscardIngredientDraftButton = ({ onCompleted }: DiscardIngredientDraftButtonProps) => {
  const { t } = useTranslation();
  const { modal } = App.useApp();
  const { ingredient } = useIngredient();
  const [discardDraft, { loading }] = useMutation(DiscardIngredientDraftDocument, { onCompleted });

  return (
    <>
      <LoadingBlocker loading={loading} />
      <Button
        danger
        icon={<UndoOutlined />}
        loading={loading}
        onClick={() =>
          modal.confirm({
            title: t("ingredients.discardDraftTitle"),
            content: t("ingredients.discardDraftConfirm"),
            okButtonProps: { danger: true, icon: <UndoOutlined /> },
            cancelButtonProps: { icon: <CloseOutlined /> },
            okText: t("ingredients.discardDraft"),
            onOk: () => discardDraft({ variables: { id: ingredient.id } }),
          })
        }
      >
        {t("ingredients.discardDraft")}
      </Button>
    </>
  );
};
